<div class="row">
  <div class="col d-flex justify-content-center mt-3">
    <div class="login-error-icon"></div>
  </div>
</div>

<div class="row">
  <div class="col d-flex justify-content-center text-center pl-5 pr-5">
    <span
      class="text text-title pl-5 pr-5"
      [innerHTML]="'home.shop.purchase-errors.' + errorCode + '.title' | translate"></span>
  </div>
</div>

<div class="row mt-2">
  <div class="col d-flex justify-content-center text-center pl-5 pr-5">
    <span
      class="text text-subtitle pl-5 pr-5"
      [innerHTML]="'home.shop.purchase-errors.' + errorCode + '.subtitle' | translate"></span>
  </div>
</div>

<div class="row mt-4">
  <div class="col d-flex justify-content-center text-center pl-5 pr-5">
    <span
      class="text text-content pl-5 pr-5"
      [innerHTML]="'home.shop.purchase-errors.' + errorCode + '.message' | translate"></span>
  </div>
</div>

<div class="row">
  <div class="col d-flex justify-content-center">
    <slotcom-button
      class="c-button--pink"
      (click)="closeDialog()"
      audioType="functionality">
      {{ 'home.buttons.ok' | translate }}
    </slotcom-button>
  </div>
</div>
